module.exports = " <div> <v-header :seller=seller> v-header </v-header> <div class=\"tab border-1px\"> <div class=tab-item> <a v-link=\"{path:'/goods'}\" href=\"\">商品</a> </div> <div class=tab-item> <a v-link=\"{path:'/ratings'}\" href=\"\">评论</a> </div> <div class=tab-item> <a v-link=\"{path:'/seller'}\" href=\"\">商家</a> </div> </div> <router-view :seller=seller></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/_eslint-loader@1.7.1@eslint-loader!./src/App.vue
// module id = 17
// module chunks = 1